import { generatePath } from 'react-router-dom';

import { ROUTES } from '#client/manifest';

import { processMenu } from '../utils/menu';

/**
 * Get the education studio menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  order?: number
 * }} params
 * @returns {object}
 */
export function getEducationStudioMenu({ businessEntityUuid, order }) {
  return processMenu({
    title: 'Education Studio',
    icon: 'ribbon-fill.svg',
    path: generatePath(ROUTES.educationStudio, { businessEntityUuid }),
    order
  });
}
